/**
 * 調整單列印：扁平 lines[].invStock.id，依 stockNo 升序（空值最後）。
 *
 * @param {object[]} [lines]
 * @returns {string[]}
 */
export function collectAdjustmentPrintInventoryStockIds(lines = []) {
  const items = (Array.isArray(lines) ? lines : [])
    .map((line) => ({
      id: line?.invStock?.id,
      stockNo: String(line?.invStock?.stockNo ?? '').trim(),
    }))
    .filter((item) => Boolean(item.id));

  items.sort((left, right) => {
    const leftEmpty = !left.stockNo;
    const rightEmpty = !right.stockNo;
    if (leftEmpty && rightEmpty) {
      return String(left.id).localeCompare(String(right.id), 'zh-Hant');
    }
    if (leftEmpty) {
      return 1;
    }
    if (rightEmpty) {
      return -1;
    }
    const byStockNo = left.stockNo.localeCompare(right.stockNo, 'zh-Hant');
    if (byStockNo !== 0) {
      return byStockNo;
    }
    return String(left.id).localeCompare(String(right.id), 'zh-Hant');
  });

  const seen = new Set();
  const ids = [];
  items.forEach((item) => {
    if (seen.has(item.id)) {
      return;
    }
    seen.add(item.id);
    ids.push(item.id);
  });

  return ids;
}
